import { gql } from '@apollo/client';

export const GET_PLACES = gql`
  query GetPlaces(
    $latitude: Float!
    $longitude: Float!
    $keyword: String!
    $aiRerank: Boolean
  ) {
    getPlaces(
      latitude: $latitude
      longitude: $longitude
      keyword: $keyword
      aiRerank: $aiRerank
    ) {
      id
      name
      place_id
      coordinates
      address
      website
      phone
      rating
      userRatingCount
      distance
    }
  }
`;

export const SEARCH_POSTS = gql`
  query SearchPosts($input: SearchPostsInput!) {
    searchPosts(input: $input) {
      items {
        _id
        type
        title
        description
        createdAt
        imageUrl
        animalImageUrl
        animalName
        animalType
        breed
        location {
          type
          coordinates
        }
      }
      totalCount
      pageInfo {
        hasMore
        nextCursor
      }
    }
  }
`;